import { useState, useEffect, useContext } from 'react';
import { FetchContext } from '@src/scenario-editor/providers/fetch.context';
export type { FetchOnboardingQuestionsPayload } from '@src/scenario-editor/providers/fetch.context';

export interface OnboardingQuestion {
  id: string;
  label: string;
  fieldType: string;
  // LF360-1828: unlike ProfileField (useFetchProfileFields.hook.ts), the
  // fetchOnboardingQuestions() payload carries the question's own answer
  // options directly - no message-text-keyed fetchOptionsByMessage workaround
  // needed for the single/multi/picker value dropdown.
  options: string[];
}

// LF360-1828: fetchOnboardingQuestions() returns inputType using the same short
// fieldType vocabulary (single|multi|input|picker|date|time) profile fields use
// (see useFetchProfileFields.hook.ts's toShortFieldType) - passed through as-is
// here since this is a purpose-built contract (not a reused/prefixed one).
export const useFetchOnboardingQuestions = () => {
  const [onboardingQuestions, setOnboardingQuestions] = useState<OnboardingQuestion[]>([]);
  const [isLoading, setIsLoading] = useState<null | boolean>(null);
  const fetchContext = useContext(FetchContext);

  if (!fetchContext) {
    throw new Error('FetchContext is not provided');
  }

  useEffect(() => {
    const fetchOnboardingQuestions = async () => {
      try {
        setIsLoading(true);
        const onboardingQuestionsPayload = await fetchContext.fetchOnboardingQuestions();

        setOnboardingQuestions(
          (onboardingQuestionsPayload.data ?? []).map((item) => ({
            id: item.id,
            label: item.title,
            fieldType: item.inputType,
            options: item.options ?? [],
          }))
        );
        setIsLoading(false);
      } catch (e) {
        console.error(e);
      }
    };
    fetchOnboardingQuestions().catch(console.error);
  }, [fetchContext]);

  return [onboardingQuestions, isLoading];
};
